// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3tn4B","signatureButtonsRight":"ModalSign_signatureButtonsRight__-Rmq7"};